import AutoDeliveryDcxSkipPage from '@/containers/AutoDeliveryDcxPage/AutoDeliveryDcxSkipPage';
import AutoDeliverySkipPage from '@/containers/AutoDeliveryPage/AutoDeliverySkipPage';
import autoDeliveryDcxService from '@/services/autoDeliveryDcxService';

const AutoDeliverySkipPageSwitcher = (props) => {
    const isDcx = autoDeliveryDcxService.getIsAutoDeliveryDcxEnabled();

    return isDcx ? <AutoDeliveryDcxSkipPage {...props} /> : <AutoDeliverySkipPage {...props} />;
};

export default AutoDeliverySkipPageSwitcher;
